import * as React from 'react';
import {
  type IUseFormCoordinator,
  useFormCoordinator,
} from './useFormCoordinator.tsx';

export interface IFormCoordinatorContext extends IUseFormCoordinator {}

export const FormCoordinatorContext =
  React.createContext<IFormCoordinatorContext>(null as any);

/**
 * Crea il context di coordinamento dei Form.
 */
export function FormCoordinator(props: { children: React.ReactNode }) {
  const { children } = props;

  const coordinator = useFormCoordinator();

  return (
    <FormCoordinatorContext.Provider value={coordinator}>
      {children}
    </FormCoordinatorContext.Provider>
  );
}

/**
 * Ottiene il context di coordinamento dei Form
 */
export function useFormCoordinatorContext() {
  return React.useContext(FormCoordinatorContext) ?? {};
}
